import {
  CasualTournamentDetails,
  EventSchedule,
  PrizeDetails,
} from '@fantaz/shared/data-access/models';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  CASUAL_TOURNAMENT_DETAILS_FEATURE_KEY,
  CasualTournamentDetailsState,
} from './casual-tournament-details.reducer';

// Lookup the 'CasualTournamentDetails' feature state managed by NgRx
export const getCasualTournamentDetailsState =
  createFeatureSelector<CasualTournamentDetailsState>(
    CASUAL_TOURNAMENT_DETAILS_FEATURE_KEY,
  );

export const getCasualTournamentDetailsLoaded = createSelector(
  getCasualTournamentDetailsState,
  (state: CasualTournamentDetailsState) => state.loaded,
);

export const getCasualTournamentDetailsError = createSelector(
  getCasualTournamentDetailsState,
  (state: CasualTournamentDetailsState) => state.error,
);

export const getTimesUserTournamentDetailsPlayed = createSelector(
  getCasualTournamentDetailsState,
  (state: CasualTournamentDetailsState) => state.userTimesPlayed,
);
export const getCasualTournamentDetails = createSelector(
  getCasualTournamentDetailsState,
  (state: CasualTournamentDetailsState) => state.details || null,
);

export const getEventSchedule = (id: string) =>
  createSelector(getCasualTournamentDetails, (details) => {
    if (details) {
      return getES(details, id);
    }
    return null;
  });

export const getEventSchedulePrizes = (id: string) =>
  createSelector(getCasualTournamentDetails, (details) => {
    const prizeMap = new Map<number, PrizeDetails>();
    if (details) {
      const es = getES(details, id);
      if (es?.prizeDetails) {
        es?.prizeDetails.forEach((p) => {
          prizeMap.set(p.rank, p);
        });
      }
    }
    return prizeMap;
  });

function getES(details: CasualTournamentDetails, id: string) {
  const events = details.detailsForEventSchedule?.filter(
    (es: EventSchedule) => es.eventScheduleUuid === id,
  );
  return events?.length > 0 ? events[0] : undefined;
}
